import { Box, Paper, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-hot-toast';
import FormInput from '../inputs/FormInput'
import Btn from '../global/Btn'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../auth/useAuthContext'
import i18next from 'i18next';
// import AuthSocial from './AuthSocial';

const FormLogin = () => {
    let lng = i18next.language
    const form = useRef();
    const navigate = useNavigate();
    const NewLoginSchema = Yup.object().shape({
        email: Yup.string(),
        password: Yup.string(),
    });
    const { handleSubmit, reset } = useForm({
        resolver: yupResolver(NewLoginSchema),
    });

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuthContext();
    const SubmitForm = async () => {
        setLoading(true);
        try {
            const result = await login(email, password);
            console.log("🚀 ~ SubmitForm ~ result:", result)
            if (result.status === 'success') {
                toast.success(result.message);
                navigate('/');
            } else {
                toast.error(result.message);
            }
            reset();
        } catch (err) {
            console.error("🚀 ~ SubmitForm ~ Error:", err);
            console.error("🚀 ~ Error Details:", err?.response || err.message);
            toast.error(err?.response?.data?.message || 'حدث خطأ في الشبكة');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Paper
                elevation={4}
                sx={{
                    px: { md: 4, xs: 2 },
                    py: { md: 4, xs: 2 },
                    borderRadius: 3,
                    maxWidth: 420,
                    mx: 'auto',
                    bgcolor: 'background.paper',
                }}
            >
                <Typography variant="h5" textAlign="center" sx={{ mb: { md: 3, xs: 1 } }}>
                    Log In
                </Typography>

                <Box component={'form'} ref={form} onSubmit={handleSubmit(SubmitForm)}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { md: 2, xs: 1 } }}>
                        <FormInput
                            label={lng === 'ar' ? 'ادخل اسم المستخدم او البريد الإلكتروني' : 'Enter Username or Email'}
                            type="email"
                            value={email}
                            placeholder="example@example.com"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <FormInput
                            label={lng === 'ar' ? 'ادخل كلمة المرور' : 'Enter Password'}
                            type="password"
                            placeholder="*********"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Box>

                    <Box mt={3} textAlign="center" sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Btn type="submit" width="100%" widthMob="100%" disabled={loading} sx={{ mx: '0' }}>
                            {loading ? 'Loading...' : 'Log In'}
                        </Btn>
                    </Box>
                </Box>
            </Paper>
        </>
    )
}

export default FormLogin